import app from "@/app";

import clickOutside from "@/directives/clickOutside";

app
    .directive("click-outside", clickOutside)
